var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginImagePattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 582,
    viewBox: "0 0 500 582",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9410_142307)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -703.445,
    y: -53.7578,
    width: 853.695,
    height: 634.886,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-63.1738 105.411C-63.1738 75.9429 -39.2856 52.0547 -9.81791 52.0547C19.6498 52.0547 43.538 75.943 43.538 105.411V157.869H-63.1738V105.411Z",
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-63.1738 104.969H43.538C43.538 134.189 19.6497 157.876 -9.81791 157.876C-39.2856 157.876 -63.1738 134.189 -63.1738 104.969Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.249 157.876H43.5371C43.5371 128.656 67.4254 104.969 96.893 104.969C126.361 104.969 150.249 128.656 150.249 157.876Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -63.1738,
    y: 369.5,
    width: 106.712,
    height: 105.814,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -63.1738,
    y: 475.32,
    width: 106.712,
    height: 105.814,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -63.1738,
    y: 157.867,
    width: 106.712,
    height: 105.814,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -63.1738,
    y: -53.7578,
    width: 106.712,
    height: 105.814,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.5371,
    y: 157.867,
    width: 106.712,
    height: 105.814,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -63.1738,
    y: 263.688,
    width: 106.712,
    height: 105.814,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-63.1738 263.688H-9.36916C19.8507 263.688 43.538 287.375 43.538 316.595V368.62C43.538 369.107 43.143 369.502 42.656 369.502C-15.7837 369.502 -63.1738 322.127 -63.1738 263.688Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5371 369.5H97.3418C126.562 369.5 150.249 393.187 150.249 422.407C150.249 451.627 126.562 475.314 97.3417 475.314H43.5371V369.5Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5356 475.314C14.0679 475.314 -9.82031 451.627 -9.82031 422.407C-9.82031 393.187 14.0679 369.5 43.5356 369.5V475.314Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.5371,
    y: 263.688,
    width: 106.712,
    height: 105.814,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5356 263.688C43.5356 292.907 19.6473 316.595 -9.82031 316.595C-9.82031 287.375 14.0679 263.688 43.5356 263.688Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.5371,
    y: 157.867,
    width: 106.712,
    height: 105.814,
    rx: 52.9072,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.2148,
    y: 184.328,
    width: 53.3559,
    height: 52.9072,
    rx: 26.4536,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.2148,
    y: 395.953,
    width: 53.3559,
    height: 52.9072,
    rx: 26.4536,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5395 -0.851562C43.5395 28.3683 19.6513 52.0556 -9.81641 52.0556C-9.81641 22.8358 14.0719 -0.851562 43.5395 -0.851562ZM-63.1738 104.962C-63.1738 75.742 -39.2856 52.0547 -9.81791 52.0547C-9.81791 81.2745 -33.7062 104.962 -63.1738 104.962ZM-9.81791 52.0556C-39.2856 52.0556 -63.1738 28.3683 -63.1738 -0.851562C-33.7062 -0.851562 -9.81791 22.8358 -9.81791 52.0556ZM-9.81641 52.0547C19.6513 52.0547 43.5395 75.742 43.5395 104.962C14.0719 104.962 -9.81641 81.2745 -9.81641 52.0547Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5371 -0.850643C43.5371 -30.0705 67.2245 -53.7578 96.4443 -53.7578H150.249V52.0565H96.4443C67.2244 52.0565 43.5371 28.3692 43.5371 -0.850643Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.2148,
    y: -27.2969,
    width: 53.3559,
    height: 52.9072,
    rx: 26.4536,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.247 475.32C150.247 504.54 126.358 528.227 96.8906 528.227C96.8906 499.008 120.779 475.32 150.247 475.32ZM43.5352 581.134C43.5352 551.914 67.4234 528.227 96.8911 528.227C96.8911 557.446 73.0028 581.134 43.5352 581.134ZM96.8911 528.227C67.4234 528.227 43.5352 504.54 43.5352 475.32C73.0028 475.32 96.8911 499.008 96.8911 528.227ZM96.8906 528.227C126.358 528.227 150.247 551.914 150.247 581.134C120.779 581.134 96.8906 557.446 96.8906 528.227Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.086 78.5083C133.861 94.3223 116.617 104.962 96.8682 104.962C77.119 104.962 59.8759 94.3223 50.6504 78.5083C59.8759 62.6943 77.119 52.0547 96.8682 52.0547C116.617 52.0547 133.861 62.6943 143.086 78.5083Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.248,
    y: -0.671875,
    width: 853.695,
    height: 634.886,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.385,
    y: -0.671875,
    width: 106.712,
    height: 105.814,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.961 263.86C256.961 234.64 280.648 210.953 309.868 210.953H363.673V316.767H309.868C280.648 316.767 256.961 293.08 256.961 263.86Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.385,
    y: 210.953,
    width: 106.712,
    height: 105.814,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.41,
    y: 316.344,
    width: 108.31,
    height: 105.162,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.385,
    y: 528.406,
    width: 106.712,
    height: 105.814,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.672,
    y: 210.953,
    width: 106.712,
    height: 105.814,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.385,
    y: 422.586,
    width: 106.712,
    height: 105.814,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.385,
    y: 105.141,
    width: 106.712,
    height: 105.814,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.385 52.684C470.385 23.2163 494.273 -0.671875 523.741 -0.671875C553.208 -0.671875 577.097 23.2164 577.097 52.6841V105.142H470.385V52.684Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.672 158.497C363.672 129.029 387.56 105.141 417.028 105.141C446.495 105.141 470.384 129.029 470.384 158.497V210.955H364.303C363.954 210.955 363.672 210.672 363.672 210.324V158.497Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.672 581.762C363.672 552.294 387.56 528.406 417.028 528.406C446.495 528.406 470.384 552.295 470.384 581.762V634.221H364.303C363.954 634.221 363.672 633.938 363.672 633.589V581.762Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.385 210.953H577.097C577.097 240.173 553.208 263.86 523.741 263.86C494.273 263.86 470.385 240.173 470.385 210.953Z",
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.055 321.732C257.055 318.756 259.467 316.344 262.442 316.344H364.613V367.726C364.613 397.428 340.535 421.505 310.834 421.505C281.132 421.505 257.055 397.428 257.055 367.726V321.732Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.097 422.595H470.385C470.385 393.375 494.273 369.688 523.741 369.688C553.208 369.688 577.097 393.375 577.097 422.595Z",
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.384 316.774H363.672C363.672 287.555 387.56 263.867 417.028 263.867C446.495 263.867 470.384 287.555 470.384 316.774Z",
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.672,
    y: 316.773,
    width: 106.712,
    height: 105.814,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.672 422.586H470.384V475.044C470.384 504.512 446.495 528.4 417.028 528.4C387.56 528.4 363.672 504.512 363.672 475.044V422.586Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.098 -53.5781C577.098 -24.3583 553.21 -0.670956 523.742 -0.670956C523.742 -29.8908 547.63 -53.5781 577.098 -53.5781ZM470.385 52.2353C470.385 23.0155 494.273 -0.671875 523.741 -0.671875C523.741 28.5479 499.852 52.2353 470.385 52.2353ZM523.741 -0.670956C494.273 -0.670956 470.385 -24.3583 470.385 -53.5781C499.852 -53.5781 523.741 -29.8908 523.741 -0.670956ZM523.742 -0.671875C553.21 -0.671875 577.098 23.0155 577.098 52.2353C547.63 52.2353 523.742 28.5479 523.742 -0.671875Z",
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.248,
    y: 528.406,
    width: 106.712,
    height: 105.814,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.248,
    y: 105.141,
    width: 106.712,
    height: 105.814,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.248,
    y: 317.102,
    width: 110.567,
    height: 105.162,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.248,
    y: 210.953,
    width: 106.712,
    height: 105.814,
    rx: 52.9072,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.961 210.953H363.673C363.673 240.173 339.785 263.86 310.317 263.86C280.849 263.86 256.961 240.173 256.961 210.953Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.961,
    y: 105.141,
    width: 106.712,
    height: 105.814,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.673 105.79H256.961C256.961 76.5702 280.849 52.8828 310.317 52.8828C339.785 52.8828 363.673 76.5702 363.673 105.79Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.672 -0.671875C363.672 28.5479 339.784 52.2353 310.316 52.2353C310.316 23.0155 334.205 -0.671875 363.672 -0.671875Z",
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.961 105.79C256.961 76.5702 280.849 52.8828 310.317 52.8828C310.317 82.1026 286.429 105.79 256.961 105.79Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.994 203.861C321.046 194.714 310.316 177.615 310.316 158.032C310.316 138.449 321.046 121.351 336.994 112.203C352.942 121.351 363.672 138.449 363.672 158.032C363.672 177.615 352.942 194.714 336.994 203.861Z",
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.961 105.141C256.961 134.36 233.073 158.048 203.605 158.048C203.605 128.828 227.494 105.141 256.961 105.141Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.961 422.588V316.773C286.429 316.773 310.317 340.461 310.317 369.681C310.317 398.9 286.429 422.588 256.961 422.588Z",
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.248 422.595C150.248 393.375 174.136 369.688 203.604 369.688C203.604 398.907 179.716 422.595 150.248 422.595Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.248,
    y: -0.671875,
    width: 106.712,
    height: 105.814,
    rx: 52.9072,
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.248 210.954C150.248 181.734 174.136 158.047 203.604 158.047C203.604 187.267 179.716 210.954 150.248 210.954Z",
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.385 316.774C470.385 287.555 494.273 263.867 523.741 263.867C523.741 293.087 499.852 316.774 470.385 316.774Z",
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.283 521.291C214.335 512.143 203.605 495.045 203.605 475.462C203.605 455.879 214.335 438.781 230.283 429.633C246.232 438.781 256.961 455.879 256.961 475.462C256.961 495.045 246.232 512.143 230.283 521.291ZM176.926 521.291C160.978 512.143 150.248 495.045 150.248 475.462C150.248 455.879 160.978 438.781 176.926 429.633C192.874 438.781 203.604 455.879 203.604 475.462C203.604 495.045 192.874 512.143 176.926 521.291Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.672,
    y: 422.586,
    width: 106.712,
    height: 105.814,
    rx: 52.9072,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.316,
    y: 369.688,
    width: 106.712,
    height: 105.814,
    rx: 52.9072,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.672,
    y: 316.773,
    width: 106.712,
    height: 105.814,
    rx: 52.9072,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.352,
    y: 237.414,
    width: 53.3559,
    height: 52.9072,
    rx: 26.4536,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.926,
    y: 237.414,
    width: 53.3559,
    height: 52.9072,
    rx: 26.4536,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.062,
    y: 449.039,
    width: 53.3559,
    height: 52.9072,
    rx: 26.4536,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.637,
    y: 449.039,
    width: 53.3559,
    height: 52.9072,
    rx: 26.4536,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.926,
    y: 449.039,
    width: 53.3559,
    height: 52.9072,
    rx: 26.4536,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.637,
    y: 344.719,
    width: 53.3559,
    height: 52.9072,
    rx: 26.4536,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497.062,
    y: 184.508,
    width: 53.3559,
    height: 52.9072,
    rx: 26.4536,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.672 -0.671875H470.384V51.7866C470.384 81.2542 446.495 105.142 417.028 105.142C387.56 105.142 363.672 81.2542 363.672 51.7865V-0.671875Z",
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.027 52.2353C417.027 23.0155 440.916 -0.671875 470.383 -0.671875C470.383 28.5479 446.495 52.2353 417.027 52.2353Z",
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.961,
    y: 528.406,
    width: 106.712,
    height: 105.814,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.673 528.399H256.961C256.961 499.18 280.849 475.492 310.317 475.492C339.785 475.492 363.673 499.18 363.673 528.399Z",
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.605 581.313C203.605 552.094 227.494 528.406 256.961 528.406C256.961 557.626 233.073 581.313 203.605 581.313Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.83 -0.671413C233.194 -0.791451 256.961 -24.4326 256.961 -53.5781C227.494 -53.5781 203.606 -29.8913 203.605 -0.671875M203.83 -0.671413C233.194 -0.551376 256.961 23.0898 256.961 52.2353C227.494 52.2353 203.606 28.5484 203.605 -0.670956M150.248 52.2353C150.248 23.0898 174.015 -0.55138 203.379 -0.671417L203.604 -0.670956C203.603 28.5484 179.715 52.2353 150.248 52.2353ZM150.248 -53.5781C150.248 -24.4326 174.015 -0.791454 203.379 -0.671417L203.604 -0.671875C203.603 -29.8913 179.715 -53.5781 150.248 -53.5781Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.383 369.68C470.383 398.9 446.495 422.587 417.027 422.587C417.027 393.367 440.916 369.68 470.383 369.68ZM363.672 475.493C363.672 446.273 387.56 422.586 417.028 422.586C417.028 451.806 393.14 475.493 363.672 475.493ZM417.028 422.587C387.56 422.587 363.672 398.9 363.672 369.68C393.14 369.68 417.028 393.367 417.028 422.587ZM417.027 422.586C446.495 422.586 470.383 446.273 470.383 475.493C440.916 475.493 417.027 451.806 417.027 422.586Z",
    fill: "#0C1356"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9410_142307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 582,
    rx: 9.23836,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImagePattern);
export default __webpack_public_path__ + "static/media/login-image-pattern.670ef24adef46fbf8a7bb9132085a99e.svg";
export { ForwardRef as ReactComponent };